export const locales = ['en', 'es', 'pt', 'fr', 'de', 'it', 'ja', 'ko', 'zh', 'ru', 'ar', 'hi', 'nl', 'pl', 'tr'] as const;
export type Locale = typeof locales[number];

export const defaultLocale: Locale = 'en';

// This is a simple configuration for client-side usage
export async function getMessages(locale: Locale = defaultLocale) {
  try {
    return (await import(`./messages/${locale}.json`)).default;
  } catch (error) {
    console.warn(`Failed to load messages for ${locale}, falling back to ${defaultLocale}`);
    return (await import(`./messages/${defaultLocale}.json`)).default;
  }
}
